
import state from './modulePersediaanState.js'
import mutations from './modulePersediaanMutations.js'
import actions from './modulePersediaanActions.js'
import getters from './modulePersediaanGetters.js'

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
